export default function (entry) {
	return this.render('form/field/radio', entry);
}
